import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {costCenterModelFactory} from "./cost-center.model";

@Injectable({providedIn: "root"})
export class CostCenterService {
  private url: string = "api/cost-center";

  constructor(private http: HttpClient) {}

  getCostCentersByProjectId(projectId: string): Promise<any> {
    return this.http.get<any[]>(`${this.url}/cost-centers-by-project`, {params: {projectId}})
      .pipe(map(array => array.map(cc => costCenterModelFactory(cc))))
      .toPromise();
  }

  saveCostCenter(costCenterList: any, customerId: string, projectId: string): Promise<any> {
    return this.http.post<any[]>(`${this.url}/create-cost-centers`, {costCenterList, customerId, projectId}, {})
      .pipe(map(json => json.map(cc => costCenterModelFactory(cc))))
      .toPromise();
  }
}
